import React, { useMemo } from 'react';
import { routes } from '@/constants/routes';
import { CalendarMonth, Home, Route, SupervisedUserCircle } from '@mui/icons-material';
import theme from '@/constants/theme';
import { NavLink } from 'react-router';

const AppTabs = () => {
  const tabs = useMemo(
    () => [
      {
        label: 'Hogar',
        path: routes.root,
        Icon: Home,
      },
      {
        label: 'Rutas',
        path: routes.routes.root,
        Icon: Route,
      },
      {
        label: 'Calendario',
        path: routes.calendar,
        Icon: CalendarMonth,
      },
      {
        label: 'Perfil',
        path: routes.profile,
        Icon: SupervisedUserCircle,
      },
    ],
    [],
  );
  return (
    <div style={styles.tabs}>
      {tabs.map((tab) => {
        return (
          <NavLink
            key={tab.path}
            to={tab.path}
            style={({ isActive }) => ({
              ...styles.tab,
              ...(isActive && styles.active),
              textDecoration: 'none',
            })}
          >
            {tab.Icon && (
              <div style={styles.icon}>
                <tab.Icon />
              </div>
            )}
            <span>{tab.label} </span>
          </NavLink>
        );
      })}
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  tabs: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    backgroundColor: theme.colors.background.primary,
    borderTop: '1px solid #ffffff36',
    padding: '8px 0',
    zIndex: 1000,
    maxHeight: 'fit-content',
  },
  tab: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'inherit',
    border: 'none',
    color: '#fff',
    fontSize: 16,
    cursor: 'pointer',
  },
  active: {
    color: theme.colors.primary,
  },
};

export default AppTabs;
